module.exports = __webpack_public_path__ + "static/poster-419e734d8559b1bfb281203956c8337c.jpg";